<div
  *ngIf="placeholder && placeholder != ''"
  [innerHTML]="placeholder | kwikuiSafeHtml"
>
</div>
